const FORM = document.getElementById('collectionFacetsForm');

async function refreshCollectionPageWithFilters(url_filters) {
  let currentUrl = "//" + window.location.host + window.location.pathname;
  let newPageString;

  try {
    newPageString = await httpGet(currentUrl + "?" + url_filters);
  } catch (error) {
    console.error('Failed to fetch new page:', error);
    return;
  }

  let newPageEl = document.createElement("DIV");
  newPageEl.innerHTML = newPageString;

  var newSection = newPageEl.querySelector(".mm-collection-grid");
  var newCounters = newPageEl.querySelectorAll(".mm-count-collection-grid");
  var activeFilters = newPageEl.querySelectorAll(".active-filters");
  var filtersTitles = newPageEl.querySelectorAll(".mm-cf-tag-filter-header p");
  var filtersInputs = newPageEl.querySelectorAll(".filter-group-display__list");
  var pagination = newPageEl.querySelector(".pagination-wrapper");

  document.querySelector(".mm-collection-grid").innerHTML = newSection.innerHTML;

  newCounters.forEach(function (newCounter, index) {
    var newActiveCounters = document.querySelectorAll(".mm-count-collection-grid");
    if (newActiveCounters[index]) {
      newActiveCounters[index].innerHTML = newCounter.innerHTML;
    }
  });

  activeFilters.forEach(function (activeFilter, index) {
    var newActiveFilters = document.querySelectorAll(".active-filters");
    if (newActiveFilters[index]) {
      newActiveFilters[index].innerHTML = activeFilter.innerHTML;
    }
  });

  filtersTitles.forEach(function (filtersTitle, index) {
    var newFiltersTitles = document.querySelectorAll(".mm-cf-tag-filter-header p");
    if (newFiltersTitles[index]) {
      newFiltersTitles[index].innerHTML = filtersTitle.innerHTML;
    }
  });

  filtersInputs.forEach(function (filtersInput, index) {
    var newFiltersInputs = document.querySelectorAll(".filter-group-display__list");
    if (newFiltersInputs[index]) {
      newFiltersInputs[index].innerHTML = filtersInput.innerHTML;
    }
  });

  if (pagination) {
    if (document.querySelector(".pagination-wrapper")) {
      document.querySelector(".pagination-wrapper").innerHTML = pagination.innerHTML;
    }
  } else {
    if (document.querySelector(".pagination-wrapper")) {
      document.querySelector(".pagination-wrapper").innerHTML = "";
    }
  }

  window.history.replaceState(null, document.title, currentUrl + "?" + url_filters);
  document.querySelector('.mm-collection-grid').classList.remove('mm-loading');
  mmLoadBlock();
  ReloadSmartWishlist();
}

function fetchWithTimeout(url, options = {}, timeout = 7000) {
  return new Promise((resolve, reject) => {
    const controller = new AbortController();
    const signal = controller.signal;
    options.signal = signal;

    const timer = setTimeout(() => {
      controller.abort();
      reject(new Error('Request timed out'));
    }, timeout);

    fetch(url, options)
      .then(response => {
        clearTimeout(timer);
        if (!response.ok) {
          reject(new Error('Network response was not ok'));
        }
        resolve(response);
      })
      .catch(error => {
        clearTimeout(timer);
        reject(error);
      });
  });
}

async function httpGet(url, retries = 3, backoff = 3000) {
  for (let i = 0; i < retries; i++) {
    try {
      const response = await fetchWithTimeout(url);
      return await response.text();
    } catch (error) {
      if (i < retries - 1) {
        console.warn(`Retry ${i + 1} failed: ${error.message}. Retrying in ${backoff / 1000} seconds...`);
        await new Promise(res => setTimeout(res, backoff));
      } else {
        console.error('Fetch error:', error);
        throw error;
      }
    }
  }
}

function checkForChanges() {
  var form = document.getElementById("collectionFacetsForm");
  var inputs = form.querySelectorAll("input");
  console.log(inputs)

	inputs.forEach(function (input) {
    input.addEventListener("change", function (e) {
      console.log(input);

      fakeSubmitForm();
      // mmInitSplide();
		});
	});
}


document.querySelectorAll('.sort_by').forEach(function(select) {
	select.addEventListener('change', function (e) {
		var value = e.target.value;
		Shopify.queryParams.sort_by = value;
		location.search = new URLSearchParams(Shopify.queryParams).toString();
	});
});

function fakeSubmitForm() {
  if (document.querySelector('html').classList.contains('stop-scrolling')) {
    document.querySelector('html').classList.remove('stop-scrolling');
  }
  if (document.querySelector('.mm-filters-filter-mobile').classList.contains('mm-visible')) {
    document.querySelector('.mm-filters-filter-mobile').classList.remove('mm-visible');
    document.querySelector('.filter-form').classList.remove('mm-open');
  }
  let form = document.getElementById("collectionFacetsForm");
  let url_filters = new URLSearchParams(new FormData(form)).toString();
  document.querySelector('.mm-collection-grid').classList.add('mm-loading');
  setTimeout(() => {
    refreshCollectionPageWithFilters(url_filters);
  }, "10");
}

function addTagsToFilters(select) {

  const options = Array.from(select.options);
  const selectedValue = select.value;

  options.forEach(option => {
    let checkbox = FORM.querySelector(`input[value="${option.value}"]`);
    if(checkbox != null) {
      if(option.value === selectedValue) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    }
  });

  mmChangeLocalStorageData(select.dataset.key, select.options[select.selectedIndex].text);
  let lsIndex = select.dataset.key + 'Index';
  mmChangeLocalStorageData(lsIndex, select.selectedIndex);
}

function addSizeToFilters(sizeString) {
  console.log('inside function')
  const size = Number(sizeString)
  const inputs = FORM.querySelectorAll('#mmFiltersSizeElement .mm-cf-filter-size');

  inputs.forEach(function(input) {
    //console.log('input', input);
    let [min, max] = input.value.replace(/,/g, '.').split('-').map(Number);
    //console.log('min', min);
    //console.log('max', max);
    //console.log('size', size);
    if(size >= min && size <= max) {
      input.checked = true;
    } else {
      input.checked = false;
    }
  })

  const local_longueur = localStorage.getItem('longueur');
  const local_max_size_selector = localStorage.getItem('max_size_selector');

  localStorage.setItem('longueur', size);
  localStorage.setItem('max_size_selector', size);

}

window.addEventListener("DOMContentLoaded", (event) => {
  mmInitSplide();
});


if (window.innerWidth < 900) {
  function mmOpenFilterFormMobile() {
    const wrapperMobile = document.querySelector(".filter-form");
    const filter = document.querySelector(".mm-filters-filter-mobile");

    wrapperMobile.classList.add("mm-open");
    filter.classList.add("mm-visible");
    document.querySelector("html").classList.add("stop-scrolling");
  }

  function mmCloseFiltersMobile() {
    var wrapperMobile = document.querySelector(".filter-form");
    const filter = document.querySelector(".mm-filters-filter-mobile");

    wrapperMobile.classList.remove("mm-open");
    filter.classList.remove("mm-visible");
    document.querySelector("html").classList.remove("stop-scrolling");
  }

}

function mmFiltersAccordeons() {
  const filtersHeaders = document.querySelectorAll('.mm-cf-tag-filter-header');

  filtersHeaders.forEach(function(filtersHeader) {
    filtersHeader.addEventListener('click', function() {
      filtersHeader.classList.toggle('mm-active');
    })
  })
}
mmFiltersAccordeons();

// SIDE CONTENTS
function mmFiltersOpenSideContent(index) {
  const panel = document.querySelector(`.mm-filters-side-content-wrapper-${index}`);

  panel.classList.add('mm-visible');
}

function mmFiltersCloseSideContent(index) {
  const panel = document.querySelector(`.mm-filters-side-content-wrapper-${index}`);

  panel.classList.remove('mm-visible');
}

function mmFiltersSideContentChangeTab(clickedTab, index) {

  // Tabs
  const tabs = document.querySelectorAll('.mm-filters-side-content-container-header-tab');
  tabs.forEach(function(tab) {
    tab.classList.remove('mm-active');
  })
  clickedTab.classList.add('mm-active');

  // Contents
  const contents = document.querySelectorAll('.mm-filters-side-content-container-tab-content');
  contents.forEach(function(content) {
    content.classList.remove('mm-visible');
  })
  document.querySelector(`.mm-filters-side-content-container-tab-content-${ index }`).classList.add('mm-visible');
}



// FOOT WIDTH ======================================================================================================

function footWidthPLP() {
  const inputs = FORM.querySelectorAll('.mm-cf-filter-tag');
  let tag_to_check;

  const width = document.querySelector('.mm-filters-interface .decimalInput.mm-collection-filter-width').value;
  const length = document.querySelector('.mm-filters-interface .decimalInput.mm-collection-filter-length').value;
  const ratio = length / width;

  const tagsInput = document.querySelector('.mm-filters-data-foot-width-tags');
  const tag1 = tagsInput.dataset.tag1;
  const tag2 = tagsInput.dataset.tag2;
  const tag3 = tagsInput.dataset.tag3;

  let steps = [];
  let stepsElems = [];
  document.querySelectorAll('.mm-filters-data-foot-width-steps').forEach(function(elem) {
    stepsElems.push(elem);
    steps.push(elem.value);
  })

  const low_size = steps[0];
  const mid_size = steps[1];
  const high_size = steps[2];
  const inf_size = steps[3];

  const low_size_elem = stepsElems[0];
  const mid_size_elem = stepsElems[1];
  const high_size_elem = stepsElems[2];
  const inf_size_elem = stepsElems[3];

  if (length < low_size) {
    const low_step = low_size_elem.dataset.lowStep;
    const high_step = low_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      tag_to_check = tag1;
    } else if (ratio <= high_step) {
      tag_to_check = tag2;
    } else if (ratio > high_step) {
      tag_to_check = tag3;
    }
  } else if (length < mid_size) {
    const low_step = mid_size_elem.dataset.lowStep;
    const high_step = mid_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      tag_to_check = tag1;
    } else if (ratio <= high_step) {
      tag_to_check = tag2;
    } else if (ratio > high_step) {
      tag_to_check = tag3;
    }
  } else if (length < high_size) {
    const low_step = high_size_elem.dataset.lowStep;
    const high_step = high_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      tag_to_check = tag1;
    } else if (ratio <= high_step) {
      tag_to_check = tag2;
    } else if (ratio > high_step) {
      tag_to_check = tag3;
    }
  } else if (length >= high_size) {
    const low_step = inf_size_elem.dataset.lowStep;
    const high_step = inf_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      tag_to_check = tag1;
    } else if (ratio <= high_step) {
      tag_to_check = tag2;
    } else if (ratio > high_step) {
      tag_to_check = tag3;
    }
  }

  inputs.forEach(function(input) {
    if(input.value == tag1 || input.value == tag2 || input.value == tag3) {
      if(input.value == tag_to_check) {
        input.checked = true;
      } else {
        input.checked = false;
      }
    }
  })

  // Display foot size info
  document.querySelectorAll('.mm-feet-size-info').forEach(function(elem) {
    elem.classList.add('mm-none');
  })
  if (tag_to_check == tag3) {
    document.querySelector('.mm-feet-size-thin').classList.remove('mm-none');
    document.querySelectorAll('.filter-group-display__list-item input[name="filter.p.m.custom.mm_largeur_des_pieds"]').forEach(function(elem) {
      elem.checked = false;
    })
    document.querySelector('input[value="fins-1"]').checked = true;
  } else if (tag_to_check == tag2) {
    document.querySelector('.mm-feet-size-medium').classList.remove('mm-none');
    document.querySelectorAll('.filter-group-display__list-item input[name="filter.p.m.custom.mm_largeur_des_pieds"]').forEach(function(elem) {
      elem.checked = false;
    })
    document.querySelector('input[value="moyens-1"]').checked = true;
  } else if (tag_to_check == tag1) {
    document.querySelector('.mm-feet-size-large').classList.remove('mm-none');
    document.querySelectorAll('.filter-group-display__list-item input[name="filter.p.m.custom.mm_largeur_des_pieds"]').forEach(function(elem) {
      elem.checked = false;
    })
    document.querySelector('input[value="larges-1"]').checked = true;
  }
}


function footWidth() {
  const inputs = FORM.querySelectorAll('.mm-cf-filter-tag');
  let tag_to_check;

  const width = document.querySelector('.mm-filters-interface .decimalInput.mm-collection-filter-width').value;
  const length = document.querySelector('.mm-filters-interface .decimalInput.mm-collection-filter-length').value;
  const ratio = length / width;

  mmChangeLocalStorageData('largeur', width);
  mmChangeLocalStorageData('longueur', length);

  const tagsInput = document.querySelector('.mm-filters-data-foot-width-tags');
  const tag1 = tagsInput.dataset.tag1;
  const tag2 = tagsInput.dataset.tag2;
  const tag3 = tagsInput.dataset.tag3;

  let steps = [];
  let stepsElems = [];
  document.querySelectorAll('.mm-filters-data-foot-width-steps').forEach(function(elem) {
    stepsElems.push(elem);
    steps.push(elem.value);
  })

  const low_size = steps[0];
  const mid_size = steps[1];
  const high_size = steps[2];
  const inf_size = steps[3];

  const low_size_elem = stepsElems[0];
  const mid_size_elem = stepsElems[1];
  const high_size_elem = stepsElems[2];
  const inf_size_elem = stepsElems[3];

  if (length < low_size) {
    const low_step = low_size_elem.dataset.lowStep;
    const high_step = low_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      tag_to_check = tag1;
    } else if (ratio <= high_step) {
      tag_to_check = tag2;
    } else if (ratio > high_step) {
      tag_to_check = tag3;
    }
  } else if (length < mid_size) {
    const low_step = mid_size_elem.dataset.lowStep;
    const high_step = mid_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      tag_to_check = tag1;
    } else if (ratio <= high_step) {
      tag_to_check = tag2;
    } else if (ratio > high_step) {
      tag_to_check = tag3;
    }
  } else if (length < high_size) {
    const low_step = high_size_elem.dataset.lowStep;
    const high_step = high_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      tag_to_check = tag1;
    } else if (ratio <= high_step) {
      tag_to_check = tag2;
    } else if (ratio > high_step) {
      tag_to_check = tag3;
    }
  } else if (length >= high_size) {
    const low_step = inf_size_elem.dataset.lowStep;
    const high_step = inf_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      tag_to_check = tag1;
    } else if (ratio <= high_step) {
      tag_to_check = tag2;
    } else if (ratio > high_step) {
      tag_to_check = tag3;
    }
  }

  inputs.forEach(function(input) {
    if(input.value == tag1 || input.value == tag2 || input.value == tag3) {
      if(input.value == tag_to_check) {
        input.checked = true;
      } else {
        input.checked = false;
      }
    }
  })
}

function loadRangeValues() {
  const widthElem = document.querySelector('.mm-filters-interface .decimalInput.mm-collection-filter-width');
  const lengthElem = document.querySelector('.mm-filters-interface .decimalInput.mm-collection-filter-length');

  const width = localStorage.getItem('largeur');
  const length = localStorage.getItem('longueur');

  if (width) {
    widthElem.value = width;
  }
  if (length) {
    lengthElem.value = length;
  }

}
function loadSelectsValues() {
  const selectElemDeplacement = document.querySelector('.mm-cf-tag-filter-elem-deplacement');
  const selectElemEpaisseur = document.querySelector('.mm-cf-tag-filter-elem-epaisseur');
  const selectElemCheville = document.querySelector('.mm-cf-tag-filter-elem-cheville');

  const deplacementIndex = localStorage.getItem('deplacementIndex');
  const epaisseurIndex = localStorage.getItem('epaisseurIndex');
  const chevilleIndex = localStorage.getItem('chevilleIndex');

  if (deplacementIndex) {
    const event = new Event("change");
    selectElemDeplacement.selectedIndex = deplacementIndex;
    selectElemDeplacement.dispatchEvent(event);
  }
  if (epaisseurIndex) {
    const event = new Event("change");
    selectElemEpaisseur.selectedIndex = epaisseurIndex;
    selectElemEpaisseur.dispatchEvent(event);
  }
  if (chevilleIndex) {
    const event = new Event("change");
    selectElemCheville.selectedIndex = chevilleIndex;
    selectElemCheville.dispatchEvent(event);
  }
}

function hasActiveFilters(url) {
    const filters = [
        'filter.v.m.custom._filtres_taille_en_cm_min_max_liste_complete_'
    ];

    for (const filter of filters) {
        if (url.includes(filter)) {
            return true;
        }
    }
    return false;
}

// SORT BY
function mmSortByChanged(select) {
  const hiddenSelect = document.getElementById('mmSortByHiddenElem');
  hiddenSelect.value = select.value;
  fakeSubmitForm();
}

function dispatchEventToLoadSizes() {
  console.log('changed')
  const event = new Event("change");
  document.querySelector('.mm-collection-filter-length').dispatchEvent(event);
  fakeSubmitForm();
}

// Check if local storage contains url - if so, we hide the blocks whith 'Do the diag !'
function mmLoadBlock() {
  if (localStorage.getItem("diag_url")) {
    document.querySelectorAll('.mm-grid-block-seo-when-not').forEach(function(elem) {
      elem.classList.remove('mm-hidden');
    })
    document.querySelectorAll('.mm-grid-block-seo-when-yes').forEach(function(elem) {
      elem.classList.add('mm-hidden');
    })
  }
}
mmLoadBlock();



function mmChangeLocalStorageDataForFootSizeCollection(storageName, input) {
  mmChangeLocalStorageData(storageName, input.value);
}


/* Truncate Description */
function mmToggleDescr() {
	let trunDescriptions = document.querySelectorAll(".mm-truncate-descr");
	trunDescriptions.forEach(function (descr) {
		descr.classList.toggle("mm-none");
	});

	// Toggle la classe pour le layout en colonne
	let heroInfos = document.querySelector(".mm-collection-hero-infos");
	if (heroInfos) {
		heroInfos.classList.toggle("mm-description-expanded");
	}
}


function doWeLoadValues() {
  const currentUrl = new URL(window.location.href);
  const params = new URLSearchParams(currentUrl.search);

  if (params.has('load_values') && params.get('load_values') === 'true') {
    loadRangeValues();
    loadSelectsValues();
    dispatchEventToLoadSizes();
  } if (hasActiveFilters(window.location.href)) {
    loadRangeValues();
    loadSelectsValues();
  }
}
doWeLoadValues();